import { FC } from "react";
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource";

const SimpleComposite: FC<WrappedComponentProps> = ({ children }) => {
  return (
    <>{children}</>
  )
}

export default withCompositeResource(SimpleComposite);
